function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCashbook = function SvgCashbook(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 15 12.3",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.7 10.7V0h-.4q-2.55.3-4.8 1.2l-.7.3v10.7l.5-.2c1.6-.7 3.2-1.1 4.9-1.2zM15 1.6h-.8V11c0 .1-.1.3-.2.3l-.7.1c-.2 0-.4 0-.6.1h-.2c-.1 0-.3 0-.4.1h-.2c-.1 0-.2 0-.4.1l-.2.1c-.1 0-.2 0-.3.1l-.2.1c-.1 0-.2.1-.3.1l-.3.1c-.1 0-.2.1-.3.1l-.2.1c-.1 0-.2.1-.3.1l-.4-.2h-.1H15zM1.7 0h-.4v10.7h.5c1.7.1 3.4.5 4.9 1.2l.5.2V1.5l-.7-.3Q4.25.3 1.7 0M0 1.6v10.7h6.1H6l-.2-.1c-.1 0-.2-.1-.3-.1l-.3-.1c-.1 0-.2-.1-.3-.1l-.2-.1c-.1 0-.2-.1-.3-.1s-.2 0-.2-.1c-.1 0-.2-.1-.3-.1l-.2-.1c-.1 0-.2 0-.4-.1h-.2c-.1 0-.3 0-.4-.1h-.2c-.2 0-.4 0-.6-.1l-.9.1c-.1 0-.2-.1-.2-.3V1.6z",
    style: {
      fill: "#414a5f"
    }
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCashbook);
export default ForwardRef;